import BaseModel from '../../common/models/base.model';

class WarrantyDictModel extends BaseModel {
  schema = {
    name: this.yup.string().required(this.requiredText),
  }

  getData() {
    return {
      ...this.data,
      // fuelType: get(this.data, 'fuelType.id'),
      // model: get(this.data, 'model.id'),
      // manufacturer: get(this.data, 'manufacturer.id'),
    };
  }
}

export default WarrantyDictModel;
